var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluvialFlood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-flood-7373155",
    transform: "translate(-9.586 -2.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    d: "M30.9,43.5V84c5.4-2.2,11.3-3.3,17.1-3.1c1.6,0,3,0.1,4.3,0.2V54h21.5v32.4c1.4,0.2,2.9,0.2,4.3,0.2 c4.3,0.1,8.5-0.7,12.4-2.4c1.4-0.5,3-1.1,4.8-1.7V43.5l6.8,5.2l7.5-8.9L63.2,4.1L16.7,39.8l7.5,8.9L30.9,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    d: "M92,100c-4.3,1.9-9,2.8-13.8,2.6c-4.7,0.1-9.4-0.8-13.7-2.6c-5.2-2.2-10.8-3.2-16.4-3.1 c-5.6-0.1-11.2,1-16.4,3.1c-4.3,1.9-9,2.8-13.7,2.6c-0.4,0-0.8,0-1.2,0v6.9c0.4,0,0.8,0,1.2,0c5.6,0.1,11.2-1,16.4-3.1 c4.3-1.9,9-2.8,13.7-2.6c4.7-0.1,9.4,0.8,13.7,2.6c5.2,2.2,10.8,3.2,16.4,3.1c5.6,0.1,11.2-1,16.4-3.1c4.3-1.9,9-2.8,13.8-2.6 c0.5,0,0.8,0,1.3,0v-6.9c-0.4,0-0.8,0-1.3,0C102.7,96.8,97.1,97.9,92,100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    d: "M92,87.4c-4.3,1.9-9,2.8-13.8,2.6c-4.7,0.1-9.4-0.8-13.7-2.6c-5.2-2.2-10.8-3.2-16.4-3.1 c-5.6-0.1-11.2,1-16.4,3.1c-4.3,1.9-9,2.8-13.7,2.6c-0.4,0-0.8,0-1.2,0v6.9c0.4,0,0.8,0,1.2,0c5.6,0.1,11.2-0.9,16.4-3.1 c4.3-1.9,9-2.8,13.7-2.6c4.7-0.1,9.4,0.8,13.7,2.6c5.2,2.2,10.8,3.2,16.4,3.1c5.6,0.1,11.3-1,16.4-3.1c4.3-1.9,9-2.8,13.8-2.6 c0.5,0,0.8,0,1.3,0v-6.9c-0.4,0-0.8,0-1.3,0C102.7,84.2,97.1,85.3,92,87.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluvialFlood);
export default __webpack_public_path__ + "static/media/fluvial-flood.4b57ca8a293e40edfefdbdb16d4e8589.svg";
export { ForwardRef as ReactComponent };